import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AppSettings } from './enums/app-settings.enum';
import { LanguageSwitchService } from './services/language-switch.service';
import { UrlService } from './services/url.service';
import { UtilitiesService } from './utilities/utilities.service';
import { filter } from 'rxjs/operators';
import { ProductService } from './services/product.service';
import { ApplicationInitializationService } from './services/application-initialization.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  title = 'eInitiative';
  loaderColor: string = AppSettings.LOADER_COLOR;
  URLS: any;
  currentUrl: string = null;
  accountList: any;
  userAccounts: any;
  loadAPI: Promise<any>;

  EISMPC: any;
  constructor(
    private UTS: UtilitiesService,
    private route: ActivatedRoute,
    private LSS: LanguageSwitchService,
    private R: Renderer2,
    private urlService: UrlService,
    private changeDetectionRef: ChangeDetectorRef,
    private router: Router,
    private productService: ProductService,
    private APPINITS: ApplicationInitializationService
  ) {
    this.UTS.log('BUILD 0.0.5 29-11-2023 National change to Union');
    this.EISMPC = this.APPINITS.environmentConfig.EINITIATIVE_SOCIAL_MEDIA_POST_CONTENT;
    this.route.queryParamMap.subscribe((params) => {
      const token: any = { ...params };
      const parentLanguage = localStorage.getItem('curr_language');
      const parentLang = (parentLanguage) ? parentLanguage.toLocaleLowerCase() : 'english';
      localStorage.removeItem('language');
      const localLanguage = localStorage.getItem('language');
      const lang = token.params.locale
        ? token.params.locale.toLowerCase()
        : token.params.lang
          ? token.params.lang.toLowerCase() : (localLanguage) ? localLanguage.toLocaleLowerCase() : 'en';

      if (lang === 'ar' || parentLang === 'arabic') {
        this.LSS.setLanguage('ar');
        this.LSS.changeLanguage();
      } else {
        this.LSS.setLanguage('en');
        this.LSS.changeLanguage();
      }
    });
  }




  ngOnInit() {
    this.changeDetectionRef.detectChanges();

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.urlService.setPreviousUrl(this.currentUrl);
      this.currentUrl = event.url;
    });
  }

  ngAfterViewInit() {
    this.UTS.getHeaders();
    setTimeout(() => {
      this.setPageOritentation(this.LSS.getLanguage())
    }, 500);
    // this.getHeaderCSSLibs(AppSettings.HEADER_LIBS);
  }
  ngOnDestroy() {
    this.destroy$.next();
  }

  setPageOritentation(lang) {
    if (lang == 'ar') {
      this.R.setAttribute(document.documentElement, 'lang', 'ar');
      this.R.setAttribute(document.body, 'dir', 'rtl');
    } else {
      this.R.setAttribute(document.documentElement, 'lang', 'en');
      this.R.setAttribute(document.body, 'dir', 'ltr');
    }
  }


  getHeaderCSSLibs(headerUrl) {
    this.productService
      .getLibs("/" + headerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
          const filteredHtml = res.htmlSrc.replace(scriptRegex, "");
          document.getElementsByTagName("head")[0].insertAdjacentHTML("beforeend", filteredHtml);
        }

      }, (e) => {

      });
  }

  getHeaderLibs(headerUrl) {
    this.productService
      .getLibs("/" + headerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('headerLibs'), 'header');

        }

      }, (e) => {

      });
  }
  getFooterLibs(footerUrl) {

    this.productService
      .getCMSContent("/" + footerUrl, 'GET')
      .subscribe((res: any) => {
        if (res?.htmlSrc) {
          this.loadScripts(res.htmlSrc, document.getElementById('footerLibs'), 'footer');
        }
      }, (e) => {

      });
  }
  loadScripts(htmlStr: string, targetEl: any, type: string) {
    let domParser = new DOMParser();
    const html = domParser.parseFromString(htmlStr, 'text/html');
    // let length = (type == 'header') ? 1 : html?.scripts.length
    for (let index = 0; index < html?.scripts.length; index++) {
      const script = html.scripts[index];
      let scriptTag = this.R.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = script.src;
      scriptTag.async = true; // makes script run asynchronously
      this.R.appendChild(targetEl, scriptTag);
    }

  }
  loadAddonScript(src: string) {
    return new Promise((resolve, reject) => {
      let script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      document.getElementsByTagName('body')[0].appendChild(script);
      resolve('');
    });
  }

}